import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-discharge_head",
  "use": "icon-discharge_head-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-discharge_head\"><path d=\"M881.664 998.4H140.288c-51.2 0-88.064-41.472-88.064-88.064V428.544c0-18.432 13.824-32.256 32.256-32.256H942.08c18.432 0 32.256 13.824 32.256 32.256v481.792c0 51.2-41.472 88.064-92.672 88.064zM358.4 864.256c13.824 0 23.04-9.216 23.04-23.04V655.36c0-13.824-9.216-23.04-23.04-23.04H209.92c-13.824 0-23.04 9.216-23.04 23.04v185.344c0 13.824 9.216 23.04 23.04 23.04h148.48zM474.112 25.6v296.448h-389.12c-18.432 0-32.256-18.432-23.04-36.864l83.456-222.208C154.624 39.424 177.664 25.6 200.704 25.6h273.408z m481.792 259.584c4.608 18.432-4.608 36.864-23.04 36.864h-384.512V25.6h268.8c23.04 0 46.08 13.824 55.808 36.864l82.944 222.72z\" p-id=\"4248\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/discharge_head.svg
// module id = j5cD
// module chunks = 39